function initCollectionGrid() {

    loadAsyncScript("/wp-content/themes/bumiller-collection/js/isotope-min.js")

    .then( data  => { 

       initGrid();

    });

    function initGrid(){

        const iso = new Isotope('.grid', {

            itemSelector: '.grid-item', // use a separate class for itemSelector, other than .col-
            layoutMode: 'masonry',
            masonry: {
              columnWidth: '.grid-sizer'
            }

        });

        // filter functions
        var filterFns = {
          // show if number is greater than 50
          numberGreaterThan50: function( itemElem ) {
            var number = itemElem.querySelector('.number').textContent;
            return parseInt( number, 10 ) > 50;
          },
          // show if name ends with -ium
          ium: function( itemElem ) {
            var name = itemElem.querySelector('.name').textContent;
            return name.match( /ium$/ );
          }
        };

        const checkboxes = document.querySelectorAll('.collection-filter-holder input');


        checkboxes.forEach(checkbox => {

          // map input values to an array
          let exclusives = [];
          let inclusives = [];

          checkbox.addEventListener('change', (event) => {

            if (event.currentTarget.checked) {

              var filterValue = event.currentTarget.value;
              // use matching filter function
              filterValue = filterFns[ filterValue ] || filterValue;
              iso.arrange({ filter: filterValue });



            } else {
 
           

            }
          })
        });

        initGridItemHover();



    }

    function initGridItemHover() {

      const gridItems =  document.querySelectorAll('.grid .grid-item');

      gridItems.forEach(gridItem => {

        const gridItemTrigger   =  gridItem.querySelector('.grid-item-trigger');
        const gridItemCaption   = gridItem.querySelector('.caption');
        const gridItemHover          = gridItem.querySelector('.btn-hover-plus');


        const tl = new TimelineMax({paused:true});
        const tl2 = new TimelineMax({paused:true});

        // create tweens for timeline
        tl.to(gridItemCaption, 0.3, {y: 0, ease: Power1.easeIn});
        tl2.to(gridItemHover, 0.3, {opacity: 1, scale: 1.1, ease: Power1.easeIn});

        gridItemTrigger.addEventListener('mouseenter', function(){
          tl.play();
          tl2.play();
        });

        gridItemTrigger.addEventListener('mouseleave', function(){
          tl.reverse();
          tl2.reverse();
        });

      });

    }

}
